module.exports = __webpack_public_path__ + "static/media/assassinationclassroom.32cf2225.jpg";